var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h6',[_vm._v("Number of respins")]),_c('multiplier',{attrs:{"disabled":_vm.disabled,"min":0,"max":100,"step":1},model:{value:(_vm.model.rules.respins),callback:function ($$v) {_vm.$set(_vm.model.rules, "respins", $$v)},expression:"model.rules.respins"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }